import React from 'react';

import { fg } from '@confluence/feature-gating';

import { PageSegmentLoadEnd } from '../PageSegmentLoadEnd.tsx';
import type { Props } from '../PageSegmentLoadEnd.tsx';

import { UFOSegmentLoadEnd } from './UFOSegmentLoadEnd.tsx';

/**
 * Interop component that renders either the new UFOSegmentLoadEnd (which calls
 * addUFOCustomData directly) or the legacy PageSegmentLoadEnd (which feeds data
 * through BM3) based on the `confluence_fe_deprecate_bm3` feature gate.
 *
 * Drop-in replacement for PageSegmentLoadEnd during the BM3 deprecation migration.
 */
export const SegmentLoadEnd = (props: Props) => {
	if (fg('confluence_fe_deprecate_bm3')) {
		return <UFOSegmentLoadEnd {...props} />;
	}

	return <PageSegmentLoadEnd {...props} />;
};
